// Custom JS goes here ------------

console.log('-- crowtoes --');
function random(min,max) {
  const num = Math.floor(Math.random()*(max-min)) + min;
  return num;
}
function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
var ct_sharing = [
	{
		name: 'facebook',
		title: 'Facebook',
		share : "https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(document.URL)+"&t="+encodeURIComponent(document.URL),
	},
	{
		name: 'twitter',
		title: 'Twitter',
		share : "https://twitter.com/intent/tweet?text=%20Check%20up%20this%20awesome%20content%20" + encodeURIComponent(document.title)+":%20 "+encodeURIComponent(document.URL),
	},
	{
		name: 'pinterest',
		title: 'Pinterest',
		share : "http://pinterest.com/pin/create/button/?url="+encodeURIComponent(document.title)+"&media="+encodeURIComponent(document.title)+"&description="+encodeURIComponent(document.URL),
	},
	{
		name: 'linkedin',
		title: 'LinkedIn',
		share : "http://www.linkedin.com/shareArticle?mini=true&url="+encodeURIComponent(document.URL)+"&title="+encodeURIComponent(document.title),
	},
	{
		name: 'email',
		title: 'Email',
		share : "mailto:?subject="+encodeURIComponent(document.title)+"&body="+encodeURIComponent(document.URL),
	},
	{
		name: 'whatsapp',
		title: 'WhatsApp',
		share : "whatsapp://send?text="+encodeURIComponent(document.title)+"&body="+encodeURIComponent(document.URL),
	}
];
(function($){
	$(document).ready(function(){

		// Check for dataLayer
		if ( typeof dataLayer != 'undefined' ) {
			// Set cookie for logged in admins / editors to filter traffic
			if( $('body').hasClass('ct_internal_traffic') ) {
				createCookie('ct_internal_traffic', 'true', 365);
			}
			if( readCookie('ct_internal_traffic') ) {
					dataLayer.push({'ct_internal_traffic':'true'});
			}
		} else {
			console.log('Add Google Tag Manager to Divi Options Integrations Page and Install Google Tag Manager for WordPress Plugin to Set Up dataLayer for Enhanced Ecommerce Tracking and to exclude internal traffic.');
		}
		// Sharing Links
		if ( $('.ct_social_share_set').length ) {
			$('.ct_social_share_set').each(function(){
				var the_set = $(this);
				ct_sharing.forEach( platform => {
					var the_link = the_set.find('.et-social-'+platform.name).find('a')[0];
					if (the_link) {
						$(the_link).find('span').text('Share');
						the_link.href = platform.share;
						the_link.title = 'Share on '+platform.title;
					}
				});
			});
		}
		// Pop Up
		function ct_pop_init(){
			let pop = $('#ct_form_pop');
			let button_text = pop.find('.nf-form-cont').closest('.et_pb_module').data('button-text');
			let ac_tag = pop.find('.nf-form-cont').closest('.et_pb_module').data('ac-tag');
			let form_delay = pop.data('form-delay');
			console.log(ac_tag);
			$('#ct_pop_button').text(button_text);
			$('.ac_tag_field').val(ac_tag);
			let path = window.location.pathname.replace(/[\/ _-]/g,'');
			// USE THIS CLASS TO MANUALLY TRIGGER THE POPUP ON CLICK
			$('.ct_open_pop').each(function(){
				$(this).click(function(){
					pop.css('display','flex');
				});
			});
			pop.click(function(e){
				e.preventDefault();
				e.stopPropagation();
				if ( $(e.target).attr('id') == 'ct_form_pop' ){
					pop.css('display','none');
				}
			});
			$('.ct_close_pop').click(function(){
				pop.css('display','none');
			});
			
			$('#ct_pop_button').click(function(){
				pop.find('.submit-container').find('input').click();
			});
			$('body').mouseleave( function(){ ct_show_form('bodyleave'); });
			if ( form_delay ) { setTimeout(function(){ ct_show_form('timedelay'); }, form_delay); }
		}
		function ct_show_form(source){
			if (! readCookie('ct_pop_'+source) ){
				createCookie('ct_pop_'+source, 'true', 1);
				$('#ct_form_pop').css('display', 'flex');
			}
		}
		const builder = window.location.href.includes('et_fb=1') || window.location.href == 'about:blank';
		$(window).load(function(){
			if (! builder ){ 
				if(  $('#ct_form_pop').length ){ ct_pop_init(); }
			}
		});

	});
	$(document).on('nfFormReady', function(){
		nfRadio.channel("forms").on('submit:response', function(e) {
			if (! e.errors.length ) {
				console.log('submit: ', e);
				$('#ct_pop_button').hide();
				$('#ct_pop_text').hide();
			}
		});
	});
})(jQuery);